import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => (
  <Link
    to="/"
    data-testid="logo-link"
    className={`font-heading font-extrabold tracking-tight leading-none ${className}`}
  >
    <span className={light ? "text-white" : "text-navy"}>YANA</span>
    <span className="text-gold">CAPITAL</span>
    <span className={`block text-[0.6rem] font-sans font-medium tracking-[0.35em] mt-0.5 ${light ? "text-slate-300" : "text-slate-500"}`}>
      GROUP
    </span>
  </Link>
);

export default Logo;
